<template lang="pug">
	span.second
		a(@click='savingInfo()')
			easyBtn(btnText="Save" v-if="!isSaving")
			img.loading-animation(:src='savingAnimation' v-if="isSaving")
</template>

<script>
import easyBtn from 'Common/components/easy-btn.vue'
import {EventBus} from '@/common/event-bus'
import savingImage from '@/common/img/Spinner-1s-200px.svg'
export default {
	name: 'saveBtn',
	data () {
		return {
			isSaving: false,
			typeOfBtn: 'save',
			savingAnimation: savingImage
		}
	},
	components: {
		easyBtn
	},
	methods: {
		savingInfo () {
			this.isSaving = true
			setTimeout(this.hideSavingAnimation, 900)
			EventBus.$emit('saving-info', this.typeOfBtn)
		},
		hideSavingAnimation () {
			this.isSaving = false
		}
	},
	showModalFromInfo () {
		EventBus.$emit('open-type-building-popUp')
	}
}
</script>



// WEBPACK FOOTER //
// src/common/components/saveBtn.vue